// extracted by mini-css-extract-plugin
export default {"form":"SearchInput_form__rgfWQ","input":"SearchInput_input__oXb+b","tools":"SearchInput_tools__K54Ls","tool":"SearchInput_tool__Y1XkF","tool_icon":"SearchInput_tool_icon__rm2n+"};